<!-- Customer Management -->
<div class="customer-management-container">
  <!-- Page Header -->
  <div class="page-header">
    <div class="header-content">
      <div class="header-main">
        <div class="header-icon">
          <i class="fas fa-users"></i>
        </div>
        <div class="header-text">
          <h1 class="page-title">Customer Directory</h1>
          <p class="page-description">View and manage your customer records</p>
        </div>
      </div>
    </div>
  </div>

  <!-- Filters Panel -->
  <div class="filters-panel">
    <div class="search-section">
      <div class="search-box">
        <div class="search-input-wrapper">
          <i class="fa fa-light fa-magnifying-glass search-icon"></i>
          <input type="text"
                 class="search-input"
                 placeholder="Search by name, phone, or email...">
        </div>
      </div>
    </div>
    <div class="filters-section">
      <div class="filter-group">
        <div ngbDropdown class="d-inline-block" container="body">
          <button type="button" class="btn btn-filter" id="dropdownBasic1" ngbDropdownToggle>
            <i class="fas fa-calendar-alt me-2"></i>
            Filter by Date
            <i class="fas fa-chevron-down ms-2"></i>
          </button>
          <div ngbDropdownMenu aria-labelledby="dropdownBasic1">
            <button ngbDropdownItem>Today</button>
            <button ngbDropdownItem>This week</button>
            <button ngbDropdownItem>This Month</button>
            <button ngbDropdownItem>Custom</button>
          </div>
        </div>

        <div ngbDropdown class="d-inline-block" container="body">
          <button type="button" class="btn btn-filter" id="dropdownBasic1" ngbDropdownToggle>
            <i class="fas fa-user-tie me-2"></i>
            Filter by Waiter
            <i class="fas fa-chevron-down ms-2"></i>
          </button>
          <div ngbDropdownMenu aria-labelledby="dropdownBasic1">
            <button ngbDropdownItem>Today</button>
            <button ngbDropdownItem>This week</button>
            <button ngbDropdownItem>This Month</button>
            <button ngbDropdownItem>Custom</button>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Customer Table -->
  <div class="data-panel">
    <div class="panel-header">
      <div class="panel-title">
        <div class="title-icon">
          <i class="fas fa-address-book"></i>
        </div>
        <div>
          <div class="title-text">Customer List</div>
          <div class="title-subtitle">All registered customers and their details</div>
        </div>
      </div>
    </div>

    <div class="panel-body">
      <div class="table-container">
        <table class="table">
          <thead>
            <tr>
              <th>Name</th>
              <th>Phone Number</th>
              <th>Email</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>
                <div class="d-flex align-items-center gap-3">
                  <div style="width: 32px; height: 32px; border-radius: 50%; background: var(--accent-subtle); color: var(--accent); display: flex; align-items: center; justify-content: center; font-size: 12px; font-weight: 600;">
                    JC
                  </div>
                  <span style="font-size: 13px; font-weight: 500; color: var(--text-primary);">Jedd Celedon</span>
                </div>
              </td>
              <td style="font-size: 13px; color: var(--text-secondary);">1 58973765</td>
              <td style="font-size: 13px; color: var(--text-secondary);">{{ 'Josese.S@email.com' }}</td>
              <td>
                <button class="btn btn-outline-secondary btn-sm" (click)="orderHistory(1)">
                  <i class="fas fa-history me-1"></i>Order History
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</div>
